import React from 'react';
import Modal from 'components/Modal';
import GatewayModal from 'components/GatewayModal';
import { ToastContainerWrapper } from './styled';
import { toast, ToastContainer } from 'react-toastify';

const Toast = (): React.JSX.Element => (
  <ToastContainerWrapper>
    <ToastContainer closeButton={false} position={toast.POSITION.TOP_CENTER} />
  </ToastContainerWrapper>
);

const OverlayComponents = (): React.JSX.Element => (
  <>
    <Modal />
    <GatewayModal />
    <Toast />  
  </>
);

export default OverlayComponents;
